import { writable } from 'svelte/store';
export const g_tabs = writable([]);
export const g_activeTab = writable(0);
export const g_darkTheme = writable(true);
export const g_showLineNumbers = writable(true);
export const g_tree_content = writable() ;

 